module.exports = __webpack_public_path__ + "media/img/powered-ociobusiness-white-h-60f6f8baf278016e4c8dfa58eef4b1a5.png";